import { DealStatusEnum, LookbackOption, type PersistedDefaultTabProps } from '@talos/kyoko';
import type { LoanTabProps } from './Loans';

export const OPEN_LOANS_TAB_ID = 'active-loans';
export const ACTIVE_LOANS_TAB_ID = 'all-loans';

export const DEFAULT_LOAN_TABS: PersistedDefaultTabProps<LoanTabProps>[] = [
  {
    label: 'Open',
    id: OPEN_LOANS_TAB_ID,
    closable: false,
    editable: false,
    defaultFilter: {
      Statuses: [DealStatusEnum.New, DealStatusEnum.Pending, DealStatusEnum.Live], // Exclude Canceled and Expired
    },
  },
  {
    label: 'Active',
    id: ACTIVE_LOANS_TAB_ID,
    closable: false,
    editable: false,
    defaultFilter: {
      Statuses: [DealStatusEnum.Live], // Only Live status positions
    },
  },
];

export const NEW_LOAN_TAB_DEFAULTS: LoanTabProps = {
  defaultFilter: {
    _start: LookbackOption.PastWeek,
    TimestampField: 'TradeTime',
  },
};
